<div class="container u-mt60">
  <div class="row">
    <div class="col-12">
      <div class="breadcrumbs">
        <ul>
          <li>
            <a href="">
              Inicio
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="col-md-8">
      <h1 class="u-mb60 txt txt--title">
        Infracción Nº {{infractionId}}
      </h1>
    </div>
  </div>
</div>
<div class="bg--lightgrey u-pt50 u-pb70">
  <div class="container">
    <div class="row">
      <div class="col-md-8 offset-md-2">
        <div class="u-center">
          <div class="icon icon--success u-mb30"></div>
          <h2 class="u-mb30 txt txt--subtitle">
            La infracción ha sido registrada y la licencia ha sido actualizada correctamente.
          </h2>
        </div>
      </div>
      <div class="col-md-8 offset-md-2">
        <div class="u-center">
          <div class="box box--white u-mb40 u-mt20">
            <div class="row">
              <div class="col-md-8 offset-md-2">
                <p class="txt u-mb0">
                  <strong>
                    N° infracción: {{infractionId}}
                  </strong>
                </p>
                <p class="txt txt-paragraph u-mb0">
                  Una copia de la infracción fue enviada al
                  correo electrónico {{email}}
                </p>
              </div>
            </div>
          </div>
          <div class="">
            <a type="button" class="btn btn--primary" routerLink="/reports/infractions">Ir a reporte de infracciones</a>
          </div>
          <div class="u-mb50 u-mt5">
            <a class="btn btn--link btn--link--secondary" routerLink="/infractions/enter">Ingresar una nueva
              infracción</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
